import React, { useState, useContext, useImperativeHandle, forwardRef } from "react";
import { Link } from "react-router-dom";
import { Drawer, Form, Icon, Select, DatePicker, Upload, Tooltip } from "antd";
import moment from "moment";

import { validateType } from "../../../shared/utils/validateFiles";
import { FILE_SIZE } from "../../../shared/utils/constants";

import { GlobalContext } from "../../../app/providers/GlobalState";

import UploadAnexo from "../../../shared/components/Form/UploadAnexo";

const { Option } = Select;
const Dragger = Upload.Dragger;

const Anular = forwardRef(
    ({ form, tipo, dataAnular, handleChangeSelect, handleChangeDataAnular, handleSubmit, transferido, fileList, setFileList }, ref) => {
        //const [fileList, setFileList] = useState([]);
        const [loading, setLoading] = useState(false);

        const context = useContext(GlobalContext);

        let opcoes = ["Remanejado", "Desistente", "Falecido", "Transferido", "Reclassificado"];

        if (!transferido) {
            opcoes = opcoes.filter(opcao => opcao !== "Remanejado" && opcao !== "Transferido");
        }

        //if (context.id_entidade !== 33) {
        //    opcoes = opcoes.filter(opcao => opcao !== "Reclassificado");
        //}

        if (context.id_entidade === 33) {
            opcoes.push("Nunca Frequentou");
        }

        const { getFieldDecorator, validateFields } = form;

        useImperativeHandle(ref, () => ({
            validateFields: () => validateFields() // Expondo o método validateFields
        }));

        return (
            <>
                <div className="bloco-info">
                    <Form className="form-add-curso" onSubmit={handleSubmit} layout="horizontal">
                        <div className="bloco">
                            <Form.Item label="Tipo de anulação">
                                {getFieldDecorator("tipoSaida", {
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório"
                                        }
                                    ],
                                    initialValue: tipo
                                })(
                                    <Select placeholder="Selecionar" className="input-50" allowClear={true} onChange={handleChangeSelect}>
                                        {opcoes.map(opcao => (
                                            <Option value={opcao}>{opcao}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                            <Form.Item label="Data">
                                {getFieldDecorator("dataAnular", {
                                    rules: [
                                        {
                                            required: true,
                                            message: "Campo obrigatório"
                                        }
                                    ],
                                    initialValue: dataAnular
                                })(
                                    <DatePicker
                                        name="data"
                                        format="DD-MM-YYYY"
                                        placeholder="Selecionar"
                                        suffixIcon={false}
                                        clearIcon={false}
                                        onChange={handleChangeDataAnular}
                                    />
                                )}
                            </Form.Item>
                            <UploadAnexo
                                required={false}
                                titulo="Documento"
                                getFieldDecorator={getFieldDecorator}
                                fileList={fileList}
                                setFileList={setFileList}
                                form={form}
                            />
                        </div>
                    </Form>
                </div>
            </>
        );
    }
);

export default Form.create()(Anular);
